import { withStyles } from '@material-ui/core';
import { differenceInDays, parse, format } from 'date-fns';
import appConstants from '../../../../../../../appConstants';
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import ToolTip from '../../../../../../common/StyledToolTip';

const ONE_WEEK_DAYS = 7;
const ABBREVIATED_DAY_FORMAT = 'EEE';

const styles = (theme) => ({
  container: {
    fontSize: theme.textFontSize_13,
    fontWeight: 500,
    color: theme.iconColor,
    marginBottom: 16
  },
  subContainer: {
    padding: 8,
    borderRadius: '4px',
    margin: '8 0',
    width: 'fit-content',
    backgroundColor: theme.activeRadioBG,
    '&:not(:first-child)': {
      margin: '6 0 0 0'
    },
    display: 'flex',
    alignItems: 'center',
    maxWidth: "95%",
    wordBreak: "break-word"
  },
  holidayIcon: {
    paddingRight: '4px'
  }
});

const isHolidayWithinOneWeek = (dateString) => {
  const holidayDate = parse(dateString, appConstants.APP_DATE_FORMAT, new Date());
  const currentDate = new Date();
  const difference = differenceInDays(holidayDate, currentDate);
  return difference >= 0 && difference <= ONE_WEEK_DAYS;
};

const getDayOfWeek = (dateString) => {
  const date = parse(dateString, appConstants.APP_DATE_FORMAT, new Date());
  return `(${format(date, ABBREVIATED_DAY_FORMAT)})`;
};

const CustomerClosedBadge = (props) => {
  const {
    classes,
    data: { holidays = [] }
  } = props;
  const upcomingHolidays = holidays.filter((holiday) =>
    isHolidayWithinOneWeek(holiday.holidayDate)
  );
  if (upcomingHolidays.length === 0) {
    return null;
  }
  return (
    <div className={classes.container}>
      {upcomingHolidays.map((holiday) => (
        <div className={classes.subContainer}>
          {holiday.isCustomerSpecificHoliday && (
            <div className={classes.holidayIcon}>
              <ToolTip title="Customer specific holiday">
                <PersonOutlinedIcon />
              </ToolTip>
            </div>
          )}
          {`Customer closed on ${holiday.holidayDate} ${getDayOfWeek(holiday.holidayDate)}` +
            (holiday.isCustomerSpecificHoliday
              ? ` - ${holiday.holidayEndDate} ${getDayOfWeek(holiday.holidayEndDate)}`
              : '') +
            ` ${holiday.holidayName}`}
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(CustomerClosedBadge);
